import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget bg-gradient-dark px-6 pt-8 pb-1" }
const _hoisted_3 = { class: "s20 items-center gap-6 pb-6 collapse-content-flex active" }
const _hoisted_4 = { class: "s3_mobile px-4" }
const _hoisted_5 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mt-5 text-center" }
const _hoisted_8 = { class: "s4_mobile" }
const _hoisted_9 = { class: "font-normal mt-2 mb-5" }
const _hoisted_10 = { class: "font-semibold my-2" }
const _hoisted_11 = { class: "font-semibold my-2" }
const _hoisted_12 = {
  key: 0,
  class: "font-normal mb-4"
}
const _hoisted_13 = {
  key: 1,
  class: "font-normal mb-4"
}
const _hoisted_14 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_15 = {
  key: 3,
  class: "tag-state success stroke"
}
const _hoisted_16 = {
  key: 4,
  class: "tag-state notif stroke"
}
const _hoisted_17 = {
  key: 5,
  class: "tag-state danger stroke"
}
const _hoisted_18 = {
  key: 6,
  class: "flex gap-2 text-grey-200 my-3"
}
const _hoisted_19 = { class: "s4_mobile px-6" }
const _hoisted_20 = {
  key: 0,
  class: "font-normal mb-4"
}
const _hoisted_21 = { class: "text-xl" }
const _hoisted_22 = {
  key: 1,
  class: "font-normal mb-4"
}
const _hoisted_23 = {
  key: 2,
  class: "font-normal mb-4"
}
const _hoisted_24 = { class: "text-xl" }
const _hoisted_25 = {
  key: 3,
  class: "font-normal mb-4"
}
const _hoisted_26 = { class: "font-normal mb-4" }
const _hoisted_27 = { class: "text-xl" }
const _hoisted_28 = {
  key: 4,
  class: "font-normal mb-4"
}
const _hoisted_29 = { class: "text-xl" }
const _hoisted_30 = {
  key: 5,
  class: "font-normal mb-4"
}
const _hoisted_31 = {
  key: 6,
  class: "font-normal mb-4"
}
const _hoisted_32 = { class: "text-xl" }
const _hoisted_33 = {
  key: 7,
  class: "font-normal mb-4"
}
const _hoisted_34 = { class: "s9_mobile" }
const _hoisted_35 = { class: "grid2" }
const _hoisted_36 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_37 = { class: "s14" }
const _hoisted_38 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_39 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_40 = { class: "s6" }
const _hoisted_41 = { class: "secondary-font font-normal text-grey-100" }
const _hoisted_42 = { class: "s14" }
const _hoisted_43 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_44 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.8)"}
}
const _hoisted_45 = { class: "s14" }
const _hoisted_46 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_47 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_48 = { class: "s6" }
const _hoisted_49 = { class: "secondary-font font-normal text-grey-100" }
const _hoisted_50 = { class: "s14" }
const _hoisted_51 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_52 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-white-rgb), 0.1)"}
}
const _hoisted_53 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_54 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_55 = { class: "s7_mobile pt-5" }
const _hoisted_56 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_57 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_58 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_59 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_60 = { class: "s6 rounded-50 overflow-hidden item" }
const _hoisted_61 = ["src"]
const _hoisted_62 = { class: "s14 mt-5 px-5" }
const _hoisted_63 = {
  key: 0,
  class: "text-grey-900 mb-3"
}
const _hoisted_64 = {
  key: 1,
  class: "text-grey-900 mb-3"
}
const _hoisted_65 = {
  key: 2,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_66 = {
  key: 3,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_67 = {
  key: 4,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_68 = {
  key: 5,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_69 = { class: "text-grey-900 mt-4" }
const _hoisted_70 = { class: "s6_mobile px-6" }
const _hoisted_71 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_72 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_73 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_74 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_75 = {
  key: 0,
  class: "text-grey-900 my-2"
}
const _hoisted_76 = {
  key: 1,
  class: "text-grey-900 my-2"
}
const _hoisted_77 = {
  key: 2,
  class: "text-grey-900 my-2"
}
const _hoisted_78 = {
  key: 3,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_79 = {
  key: 4,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_80 = {
  key: 5,
  class: "flex gap-4"
}
const _hoisted_81 = ["src"]
const _hoisted_82 = ["src"]
const _hoisted_83 = {
  key: 6,
  class: "flex gap-4"
}
const _hoisted_84 = ["src"]
const _hoisted_85 = {
  key: 7,
  class: "flex gap-4"
}
const _hoisted_86 = { class: "s7_mobile px-6" }
const _hoisted_87 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_88 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_89 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_90 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_91 = ["href"]
const _hoisted_92 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_93 = { class: "text-grey-500" }
const _hoisted_94 = { class: "mb-5 text-grey-800" }
const _hoisted_95 = ["href"]
const _hoisted_96 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_97 = { class: "text-grey-500" }
const _hoisted_98 = { class: "mb-5 text-grey-800" }
const _hoisted_99 = ["href"]
const _hoisted_100 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_101 = { class: "text-grey-500" }
const _hoisted_102 = { class: "mb-5 text-grey-800" }
const _hoisted_103 = {
  key: 1,
  class: "text-grey-500"
}
const _hoisted_104 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_105 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_106 = { class: "s7_mobile pt-5" }
const _hoisted_107 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_108 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_109 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_110 = {
  key: 0,
  class: "text-grey-900"
}
const _hoisted_111 = {
  key: 1,
  class: "text-grey-900"
}
const _hoisted_112 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_113 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_114 = {
  key: 4,
  class: "font-semibold my-2 text-grey-800"
}
const _hoisted_115 = {
  key: 5,
  class: "font-semibold my-2 text-grey-800"
}
const _hoisted_116 = {
  key: 6,
  class: "mb-2 text-grey-800"
}
const _hoisted_117 = {
  key: 7,
  class: "mb-2 text-grey-800"
}
const _hoisted_118 = {
  key: 8,
  class: "tag-state warning stroke"
}
const _hoisted_119 = {
  key: 9,
  class: "tag-state success stroke"
}
const _hoisted_120 = {
  key: 10,
  class: "tag-state notif stroke"
}
const _hoisted_121 = {
  key: 11,
  class: "tag-state danger stroke"
}
const _hoisted_122 = { class: "s7_mobile px-6" }
const _hoisted_123 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_124 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_125 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_126 = { class: "text-grey-900 my-2" }
const _hoisted_127 = {
  key: 0,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_128 = {
  key: 1,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_129 = {
  key: 2,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_130 = {
  key: 3,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_131 = { class: "s6_mobile px-6" }
const _hoisted_132 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_133 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_134 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_135 = { class: "text-grey-900 my-2" }
const _hoisted_136 = { class: "text-grey-900 my-2" }
const _hoisted_137 = {
  key: 0,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_138 = {
  key: 1,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_139 = {
  key: 2,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_140 = {
  key: 3,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_141 = {
  key: 4,
  class: "mb-2 text-grey-800"
}
const _hoisted_142 = {
  key: 5,
  class: "mb-2 text-grey-800"
}
const _hoisted_143 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_144 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_145 = { class: "s7_mobile pt-6" }
const _hoisted_146 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_147 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_148 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_149 = {
  key: 0,
  class: "text-grey-900"
}
const _hoisted_150 = {
  key: 1,
  class: "text-grey-900"
}
const _hoisted_151 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_152 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_153 = {
  key: 4,
  class: "mb-2 text-grey-800"
}
const _hoisted_154 = {
  key: 5,
  class: "mb-2 text-grey-800"
}
const _hoisted_155 = {
  key: 6,
  class: "tag-state warning stroke"
}
const _hoisted_156 = {
  key: 7,
  class: "tag-state success stroke"
}
const _hoisted_157 = {
  key: 8,
  class: "tag-state notif stroke"
}
const _hoisted_158 = {
  key: 9,
  class: "tag-state danger stroke"
}
const _hoisted_159 = { class: "s7_mobile px-6" }
const _hoisted_160 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_161 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_162 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_163 = {
  key: 0,
  class: "text-grey-900 my-2"
}
const _hoisted_164 = {
  key: 1,
  class: "text-grey-900 my-2"
}
const _hoisted_165 = { class: "text-grey-900 my-2" }
const _hoisted_166 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_167 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_168 = {
  key: 4,
  class: "text-grey-800"
}
const _hoisted_169 = {
  key: 5,
  class: "text-grey-800"
}
const _hoisted_170 = {
  key: 6,
  class: "mb-2 text-grey-800"
}
const _hoisted_171 = {
  key: 7,
  class: "mb-2 text-grey-800"
}
const _hoisted_172 = { class: "s6_mobile px-6" }
const _hoisted_173 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_174 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_175 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_176 = {
  key: 0,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_177 = {
  key: 1,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_178 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_179 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_180 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_181 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_182 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_183 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_184 = { class: "s20 items-center gap-6 pb-4 collapse-content active" }
const _hoisted_185 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_186 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_187 = { class: "font-medium" }

import { formatAmount, formatDate } from '@/utils';
    import { useRoute } from 'vue-router';
    import { inject, ref, computed, onMounted } from 'vue';
    import axios from 'axios';
    import moment from 'moment';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersDetailsView',
  setup(__props) {

    const route = useRoute();
    const BACKEND_URL = inject('BACKEND_URL');
    const user: any = ref(route.meta.user || {});
    const loading = ref(false);
    const errorMessage = ref('');

    onMounted(async () => {
        // Recharger les données utilisateur pour s'assurer qu'elles sont à jour
        if (route.params.id) {
            try {
                const response = await axios.get(`/backoffice/users/get/${route.params.id}`);
                user.value = response.data;
            } catch (error: any) {
                console.error('Erreur lors du chargement de l\'utilisateur:', error);
            }
        }
    });

    function formatDateFrench(dateString: string | null): string {
        if (!dateString) return '';
        try {
            const date = moment(dateString);
            if (!date.isValid()) return '';
            const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
            return `${date.date()} ${monthsFr[date.month()]} ${date.year()}`;
        } catch {
            return dateString;
        }
    }

    function calculateAnciennete(dateEngagement: string | null): string {
        if (!dateEngagement) return '-';
        try {
            const engagementDate = moment(dateEngagement);
            if (!engagementDate.isValid()) return '-';
            const now = moment();
            const years = now.diff(engagementDate, 'years');
            const months = now.diff(engagementDate, 'months') % 12;
            
            if (years > 0 && months > 0) {
                return `${years} an${years > 1 ? 's' : ''} ${months} mois`;
            } else if (years > 0) {
                return `${years} an${years > 1 ? 's' : ''}`;
            } else if (months > 0) {
                return `${months} mois`;
            } else {
                return '0 mois';
            }
        } catch {
            return '-';
        }
    }

    const quotiteUsedPercent = computed(() => {
        if (!user.value.quotite_cessible_montant || !user.value.salaire || user.value.salaire <= 0) return 0;
        // Si on a une utilisation, on peut la calculer, sinon 0
        // Pour l'instant, on retourne 0 car on n'a pas de données d'utilisation
        return 0;
    });

    async function doSendConfirmationEmail() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/users/send_confirmation_email`, { users_ids: [user.value.id] });
        } catch (error: any) {
            errorMessage.value = error.response?.data?.message || 'Une erreur est survenue lors de l\'envoi de l\'email.';
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[94] || (_cache[94] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Membre / détail <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Souscription</span><span class=\"btn shadow-200 white2\">Contrat</span><span class=\"btn shadow-200 light2 border-none\">Prélèvement</span><span class=\"btn shadow-200 light2 border-none\">Premier prélèvement</span><span class=\"btn shadow-200 light2 border-none\">Décaissement mensuel</span><span class=\"btn shadow-200 light2 border-none\">Wallet / Utilisation</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _cache[33] || (_cache[33] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open-flex active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Souscription </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn-ultra color2\"><div class=\"btn-show\"><img src=\"/icons/icon-actif.svg\" class=\"btn-icon\" alt=\"\"><span>Actif</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button><button class=\"btn-ultra\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button><button class=\"btn lg py-3 white2\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Utilisation</span></button></div><div class=\"clear-both h-10\"></div>", 3)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: !!user.value.photo_url ? user.value.photo_url : '/assets/users_avatar/600w/user.jpg',
              width: "100%"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(user.value.email || user.value.telephone || 'N/A'), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", null, _toDisplayString(user.value.nom + ' ' + user.value.prenom), 1),
          _createElementVNode("h4", _hoisted_9, _toDisplayString(user.value.collectivite?.nom || 'N/A'), 1),
          _createElementVNode("h6", _hoisted_10, _toDisplayString(user.value.telephone || 'N/A'), 1),
          _createElementVNode("h6", _hoisted_11, _toDisplayString(user.value.email || 'N/A'), 1),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          (user.value.date_engagement)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_12, [
                _cache[0] || (_cache[0] = _createTextVNode(" Date d'engagement ", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.date_engagement)) + " - " + _toDisplayString(calculateAnciennete(user.value.date_engagement)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_13, [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Date d'engagement ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (!user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "En cours"))
            : _createCommentVNode("", true),
          (user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Vérifié"))
            : _createCommentVNode("", true),
          (user.value.actif == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Actif"))
            : _createCommentVNode("", true),
          (user.value.actif == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Inactif"))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (user.value.last_connection_at)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  src: "/icons/icon-calendrier.svg",
                  class: "size-xs"
                }, null, -1)),
                _createTextVNode(" Dernière connexion: " + _toDisplayString(_unref(formatDate)(user.value.last_connection_at, 'DD/MM/YYYY')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _cache[32] || (_cache[32] = _createElementVNode("div", null, [
          _createElementVNode("hr", { class: "hr-vertical hr-vertical-white h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          (user.value.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_20, [
                _cache[7] || (_cache[7] = _createTextVNode(" Date de souscription ", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_21, _toDisplayString(formatDateFrench(user.value.created_at)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_22, [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" Date de souscription ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", { class: "text-xl" }, "-", -1)
              ]))])),
          (user.value.souscription?.date_fin)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_23, [
                _cache[10] || (_cache[10] = _createTextVNode(" Date de fin de souscription ", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_24, _toDisplayString(formatDateFrench(user.value.souscription.date_fin)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_25, [...(_cache[12] || (_cache[12] = [
                _createTextVNode(" Date de fin de souscription ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", { class: "text-xl" }, "-", -1)
              ]))])),
          _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "hr-white" }, null, -1)),
          _createElementVNode("h5", _hoisted_26, [
            _cache[13] || (_cache[13] = _createTextVNode(" Utilisation total ", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
            _createElementVNode("b", _hoisted_27, _toDisplayString(user.value.balance ? _unref(formatAmount)(user.value.balance) + ' F' : '0 F'), 1)
          ]),
          (user.value.salaire)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_28, [
                _cache[15] || (_cache[15] = _createTextVNode(" Salaire Net après Utilisation ", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_29, _toDisplayString(_unref(formatAmount)((user.value.salaire || 0) - (user.value.balance || 0))) + " F", 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_30, [...(_cache[17] || (_cache[17] = [
                _createTextVNode(" Salaire Net après Utilisation ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", { class: "text-xl" }, "-", -1)
              ]))])),
          (user.value.quotite_cessible_pourcent && user.value.quotite_cessible_montant)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_31, [
                _cache[18] || (_cache[18] = _createTextVNode(" Quotité cessible disponible ", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_32, _toDisplayString(user.value.quotite_cessible_pourcent) + "% - " + _toDisplayString(_unref(formatAmount)(user.value.quotite_cessible_montant)) + " F", 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_33, [...(_cache[20] || (_cache[20] = [
                _createTextVNode(" Quotité cessible disponible ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", { class: "text-xl" }, "-", -1)
              ]))]))
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "Net"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" })
              ], -1)),
              _createElementVNode("div", _hoisted_37, [
                _cache[22] || (_cache[22] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Salaire", -1)),
                _createElementVNode("h2", _hoisted_38, _toDisplayString(user.value.salaire ? _unref(formatAmount)(user.value.salaire) + ' F' : '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("h2", _hoisted_41, _toDisplayString(user.value.quotite_cessible_pourcent ? user.value.quotite_cessible_pourcent + '%' : '-'), 1),
                _cache[24] || (_cache[24] = _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[25] || (_cache[25] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Prélèvement sur salaire", -1)),
                _createElementVNode("h2", _hoisted_43, _toDisplayString(user.value.quotite_cessible_montant ? _unref(formatAmount)(user.value.quotite_cessible_montant) + ' F' : '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "Par"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois")
              ], -1)),
              _createElementVNode("div", _hoisted_45, [
                _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Mon revolving", -1)),
                _createElementVNode("h2", _hoisted_46, _toDisplayString(user.value.balance ? _unref(formatAmount)(user.value.balance) + ' F' : '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("h2", _hoisted_49, _toDisplayString(user.value.souscription?.duree_mois || '-'), 1),
                _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois", -1))
              ]),
              _createElementVNode("div", _hoisted_50, [
                _cache[29] || (_cache[29] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Pouvoir d'achat", -1)),
                _createElementVNode("h2", _hoisted_51, _toDisplayString(user.value.souscription?.montant ? _unref(formatAmount)(user.value.souscription.montant) + ' F' : '-'), 1)
              ])
            ])
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
          _createElementVNode("div", _hoisted_52, [
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Utilisation", -1)),
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
              style: _normalizeStyle(`width: ${quotiteUsedPercent.value}%;`)
            }, _toDisplayString(quotiteUsedPercent.value) + "% ", 5)
          ])
        ])
      ])
    ]),
    _cache[95] || (_cache[95] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[96] || (_cache[96] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[97] || (_cache[97] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_53, [
      _cache[49] || (_cache[49] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open-flex active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Identification / Bulettin </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn-ultra\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div><div class=\"clear-both h-5\"></div>", 3)),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("h3", _hoisted_56, [
            _cache[34] || (_cache[34] = _createTextVNode(" Identification   ", -1)),
            (user.value.kyc?.statut === 'verified')
              ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Validé"))
              : (user.value.kyc?.statut === 'rejected')
                ? (_openBlock(), _createElementBlock("span", _hoisted_58, "Rejeté"))
                : (_openBlock(), _createElementBlock("span", _hoisted_59, "En attente"))
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("img", {
              src: !!user.value.photo_url ? user.value.photo_url : '/assets/users_avatar/600w/user.jpg',
              width: "100%"
            }, null, 8, _hoisted_61)
          ]),
          _createElementVNode("div", _hoisted_62, [
            (user.value.kyc?.id)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_63, "n° CF" + _toDisplayString(user.value.created_at ? _unref(moment)(user.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(user.value.kyc.id).padStart(6, '0')), 1))
              : (_openBlock(), _createElementBlock("h4", _hoisted_64, "n° -")),
            (user.value.kyc?.created_at)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_65, "Effectuée le"))
              : _createCommentVNode("", true),
            (user.value.kyc?.created_at)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_66, _toDisplayString(_unref(formatDate)(user.value.kyc.created_at, 'DD/MM/YYYY HH:mm')), 1))
              : (user.value.created_at)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_67, _toDisplayString(_unref(formatDate)(user.value.created_at, 'DD/MM/YYYY HH:mm')), 1))
                : (_openBlock(), _createElementBlock("h5", _hoisted_68, "-")),
            _createElementVNode("h5", _hoisted_69, _toDisplayString(user.value.nom + ' ' + user.value.prenom), 1)
          ])
        ]),
        _cache[47] || (_cache[47] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("h3", _hoisted_71, [
            _cache[35] || (_cache[35] = _createTextVNode(" Pièce d'identité   ", -1)),
            (user.value.kyc?.statut === 'verified')
              ? (_openBlock(), _createElementBlock("span", _hoisted_72, "Validé"))
              : (user.value.kyc?.statut === 'rejected')
                ? (_openBlock(), _createElementBlock("span", _hoisted_73, "Rejeté"))
                : (_openBlock(), _createElementBlock("span", _hoisted_74, "En attente"))
          ]),
          (user.value.numero_piece_identite)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_75, " N° " + _toDisplayString(user.value.numero_piece_identite) + " / " + _toDisplayString(user.value.type_piece_identite || 'CNI'), 1))
            : (user.value.kyc?.piece_numero)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_76, " N° " + _toDisplayString(user.value.kyc.piece_numero) + " / " + _toDisplayString(user.value.kyc?.piece_type || 'CNI'), 1))
              : (_openBlock(), _createElementBlock("h4", _hoisted_77, " N° - / - ")),
          (user.value.kyc?.piece_expiration)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_78, [
                _cache[36] || (_cache[36] = _createTextVNode(" Date d'expiration ", -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.kyc.piece_expiration)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_79, [...(_cache[37] || (_cache[37] = [
                _createTextVNode(" Date d'expiration ", -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          (user.value.document_identite_recto || user.value.document_identite_verso)
            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                (user.value.document_identite_recto)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: user.value.document_identite_recto.fichier_url,
                      width: "100%"
                    }, null, 8, _hoisted_81))
                  : _createCommentVNode("", true),
                (user.value.document_identite_verso)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: user.value.document_identite_verso.fichier_url,
                      width: "100%"
                    }, null, 8, _hoisted_82))
                  : _createCommentVNode("", true)
              ]))
            : (user.value.kyc && user.value.kyc.kyc_documents && user.value.kyc.kyc_documents.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.kyc.kyc_documents.slice(0, 2), (doc, idx) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: idx,
                      src: doc.fichier_url,
                      width: "100%"
                    }, null, 8, _hoisted_84))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_85, [...(_cache[38] || (_cache[38] = [
                  _createElementVNode("div", { class: "text-grey-500" }, "Aucun document disponible", -1)
                ]))])),
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1))
        ]),
        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("h3", _hoisted_87, [
            _cache[40] || (_cache[40] = _createTextVNode(" Bulletins de salaires   ", -1)),
            (user.value.kyc?.statut === 'verified')
              ? (_openBlock(), _createElementBlock("span", _hoisted_88, "Validé"))
              : (user.value.kyc?.statut === 'rejected')
                ? (_openBlock(), _createElementBlock("span", _hoisted_89, "Rejeté"))
                : (_openBlock(), _createElementBlock("span", _hoisted_90, "En attente"))
          ]),
          (user.value.bulletin1_document || user.value.bulletin2_document || user.value.bulletin3_document)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (user.value.bulletin1_document)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: user.value.bulletin1_document.fichier_url,
                      target: "_blank"
                    }, [
                      _createElementVNode("h5", _hoisted_92, [
                        _cache[41] || (_cache[41] = _createTextVNode(" Bulletin 1 - ", -1)),
                        _createElementVNode("span", _hoisted_93, _toDisplayString(formatDateFrench(user.value.bulletin1_document.created_at)), 1)
                      ]),
                      _createElementVNode("h5", _hoisted_94, [
                        _cache[42] || (_cache[42] = _createElementVNode("img", {
                          src: "/icons/icon-download.svg",
                          class: "size-sm mr-2",
                          alt: ""
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(user.value.bulletin1_document.fichier || 'fichier_bulletin.pdf'), 1)
                      ])
                    ], 8, _hoisted_91))
                  : _createCommentVNode("", true),
                (user.value.bulletin2_document)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: user.value.bulletin2_document.fichier_url,
                      target: "_blank"
                    }, [
                      _createElementVNode("h5", _hoisted_96, [
                        _cache[43] || (_cache[43] = _createTextVNode(" Bulletin 2 - ", -1)),
                        _createElementVNode("span", _hoisted_97, _toDisplayString(formatDateFrench(user.value.bulletin2_document.created_at)), 1)
                      ]),
                      _createElementVNode("h5", _hoisted_98, [
                        _cache[44] || (_cache[44] = _createElementVNode("img", {
                          src: "/icons/icon-download.svg",
                          class: "size-sm mr-2",
                          alt: ""
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(user.value.bulletin2_document.fichier || 'fichier_bulletin.pdf'), 1)
                      ])
                    ], 8, _hoisted_95))
                  : _createCommentVNode("", true),
                (user.value.bulletin3_document)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: user.value.bulletin3_document.fichier_url,
                      target: "_blank"
                    }, [
                      _createElementVNode("h5", _hoisted_100, [
                        _cache[45] || (_cache[45] = _createTextVNode(" Bulletin 3 - ", -1)),
                        _createElementVNode("span", _hoisted_101, _toDisplayString(formatDateFrench(user.value.bulletin3_document.created_at)), 1)
                      ]),
                      _createElementVNode("h5", _hoisted_102, [
                        _cache[46] || (_cache[46] = _createElementVNode("img", {
                          src: "/icons/icon-download.svg",
                          class: "size-sm mr-2",
                          alt: ""
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(user.value.bulletin3_document.fichier || 'fichier_bulletin.pdf'), 1)
                      ])
                    ], 8, _hoisted_99))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("p", _hoisted_103, "Aucun bulletin disponible"))
        ])
      ])
    ]),
    _cache[98] || (_cache[98] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[99] || (_cache[99] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[100] || (_cache[100] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_104, [
      _cache[74] || (_cache[74] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open-flex active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Contrat d&#39;engagement </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn-ultra\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div><div class=\"clear-both h-5\"></div>", 3)),
      _createElementVNode("div", _hoisted_105, [
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("h3", _hoisted_107, [
            _cache[50] || (_cache[50] = _createTextVNode(" Coop Finance   ", -1)),
            (user.value.souscription_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_108, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_109, "En attente"))
          ]),
          (user.value.souscription_id)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_110, " Contrat n° / CF" + _toDisplayString(user.value.created_at ? _unref(moment)(user.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(user.value.souscription_id).padStart(6, '0')), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_111, "Contrat n° / -")),
          (user.value.souscription?.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_112, " Signé le " + _toDisplayString(formatDateFrench(user.value.souscription.created_at)), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_113, "Signé le -")),
          (user.value.date_engagement)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_114, " Durée: " + _toDisplayString(calculateAnciennete(user.value.date_engagement)), 1))
            : (_openBlock(), _createElementBlock("h6", _hoisted_115, "Durée: -")),
          _cache[51] || (_cache[51] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[52] || (_cache[52] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant du contrat", -1)),
          (user.value.souscription?.montant)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_116, _toDisplayString(_unref(formatAmount)(user.value.souscription.montant)) + " F", 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_117, "-")),
          _cache[53] || (_cache[53] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (!user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_118, "En cours"))
            : _createCommentVNode("", true),
          (user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_119, "Vérifié"))
            : _createCommentVNode("", true),
          (user.value.actif == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_120, "Actif"))
            : _createCommentVNode("", true),
          (user.value.actif == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_121, "Inactif"))
            : _createCommentVNode("", true)
        ]),
        _cache[72] || (_cache[72] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_122, [
          _createElementVNode("h3", _hoisted_123, [
            _createTextVNode(_toDisplayString(user.value.collectivite?.nom || 'Collectivité') + "   ", 1),
            (user.value.collectivite_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_124, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_125, "En attente"))
          ]),
          _createElementVNode("h4", _hoisted_126, "Identifiant / " + _toDisplayString(user.value.email || user.value.telephone || 'N/A'), 1),
          (user.value.date_engagement)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_127, [
                _cache[54] || (_cache[54] = _createTextVNode(" Date de début de contrat ", -1)),
                _cache[55] || (_cache[55] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.date_engagement)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_128, [...(_cache[56] || (_cache[56] = [
                _createTextVNode(" Date de début de contrat ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          (user.value.souscription?.date_fin)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_129, [
                _cache[57] || (_cache[57] = _createTextVNode(" Date de fin de contrat ", -1)),
                _cache[58] || (_cache[58] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.souscription.date_fin)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_130, [...(_cache[59] || (_cache[59] = [
                _createTextVNode(" Date de fin de contrat ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          _cache[60] || (_cache[60] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[61] || (_cache[61] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Fond de la collectivité", -1)),
          _cache[62] || (_cache[62] = _createElementVNode("h4", { class: "mb-2 text-grey-800" }, "-", -1))
        ]),
        _cache[73] || (_cache[73] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_131, [
          _createElementVNode("h3", _hoisted_132, [
            _cache[63] || (_cache[63] = _createTextVNode(" Membre   ", -1)),
            (user.value.email_verified_at && user.value.actif == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_133, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_134, "En attente"))
          ]),
          _createElementVNode("h4", _hoisted_135, "Identifiant / " + _toDisplayString(user.value.email || user.value.telephone || 'N/A'), 1),
          _createElementVNode("h4", _hoisted_136, _toDisplayString(user.value.nom + ' ' + user.value.prenom), 1),
          (user.value.date_engagement)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_137, [
                _cache[64] || (_cache[64] = _createTextVNode(" Date de début de contrat ", -1)),
                _cache[65] || (_cache[65] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.date_engagement)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_138, [...(_cache[66] || (_cache[66] = [
                _createTextVNode(" Date de début de contrat ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          (user.value.souscription?.date_fin)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_139, [
                _cache[67] || (_cache[67] = _createTextVNode(" Date de fin de contrat ", -1)),
                _cache[68] || (_cache[68] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.souscription.date_fin)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_140, [...(_cache[69] || (_cache[69] = [
                _createTextVNode(" Date de fin de contrat ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          _cache[70] || (_cache[70] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[71] || (_cache[71] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Prélèvement mensuel", -1)),
          (user.value.quotite_cessible_montant)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_141, _toDisplayString(_unref(formatAmount)(user.value.quotite_cessible_montant)) + " F", 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_142, "-"))
        ])
      ])
    ]),
    _cache[101] || (_cache[101] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[102] || (_cache[102] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[103] || (_cache[103] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_143, [
      _cache[90] || (_cache[90] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open-flex active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Premier prélèvement / Carte </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 white2 active\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Carte</span></button></div><div class=\"clear-both h-0\"></div>", 3)),
      _createElementVNode("div", _hoisted_144, [
        _createElementVNode("div", _hoisted_145, [
          _createElementVNode("h3", _hoisted_146, [
            _cache[75] || (_cache[75] = _createTextVNode(" Premier prélèvement   ", -1)),
            (user.value.souscription_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_147, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_148, "En attente"))
          ]),
          (user.value.souscription_id)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_149, " Signature / CF" + _toDisplayString(user.value.created_at ? _unref(moment)(user.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(user.value.souscription_id).padStart(6, '0')), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_150, "Signature / -")),
          (user.value.souscription?.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_151, " Effectué le " + _toDisplayString(_unref(formatDate)(user.value.souscription.created_at, 'DD/MM/YYYY HH:mm')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_152, "-")),
          _cache[76] || (_cache[76] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[77] || (_cache[77] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant du prélèvement", -1)),
          (user.value.quotite_cessible_montant)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_153, _toDisplayString(_unref(formatAmount)(user.value.quotite_cessible_montant)) + " F", 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_154, "-")),
          _cache[78] || (_cache[78] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (!user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_155, "En cours"))
            : _createCommentVNode("", true),
          (user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_156, "Vérifié"))
            : _createCommentVNode("", true),
          (user.value.actif == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_157, "Actif"))
            : _createCommentVNode("", true),
          (user.value.actif == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_158, "Inactif"))
            : _createCommentVNode("", true)
        ]),
        _cache[88] || (_cache[88] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_159, [
          _createElementVNode("h3", _hoisted_160, [
            _cache[79] || (_cache[79] = _createTextVNode(" Création de la carte   ", -1)),
            (user.value.cartes && user.value.cartes.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_161, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_162, "En attente"))
          ]),
          (user.value.cartes && user.value.cartes.length > 0)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_163, " **** **** **** " + _toDisplayString(user.value.cartes[0].numero_carte ? user.value.cartes[0].numero_carte.slice(-4) : '****'), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_164, "**** **** **** ****")),
          _createElementVNode("h4", _hoisted_165, _toDisplayString(user.value.collectivite?.nom || 'N/A'), 1),
          (user.value.cartes && user.value.cartes[0]?.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_166, " Créé le " + _toDisplayString(_unref(formatDate)(user.value.cartes[0].created_at, 'DD/MM/YYYY HH:mm')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_167, "-")),
          _cache[80] || (_cache[80] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          (user.value.cartes && user.value.cartes[0]?.rib)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_168, "RIB / " + _toDisplayString(user.value.cartes[0].rib), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_169, "RIB / -")),
          _cache[81] || (_cache[81] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[82] || (_cache[82] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant disponible", -1)),
          (user.value.balance)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_170, _toDisplayString(_unref(formatAmount)(user.value.balance)) + " F", 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_171, "-"))
        ]),
        _cache[89] || (_cache[89] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_172, [
          _createElementVNode("h3", _hoisted_173, [
            _cache[83] || (_cache[83] = _createTextVNode(" Livraison   ", -1)),
            (user.value.cartes && user.value.cartes[0]?.date_livraison)
              ? (_openBlock(), _createElementBlock("span", _hoisted_174, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_175, "En attente"))
          ]),
          _cache[85] || (_cache[85] = _createElementVNode("h5", { class: "text-grey-900 my-2" }, "Point relais - collectivité", -1)),
          (user.value.cartes && user.value.cartes[0]?.date_livraison)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_176, " Livré le " + _toDisplayString(_unref(formatDate)(user.value.cartes[0].date_livraison, 'DD/MM/YYYY HH:mm')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_177, "-")),
          _cache[86] || (_cache[86] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          _createElementVNode("h3", _hoisted_178, [
            _cache[84] || (_cache[84] = _createTextVNode(" Réception   ", -1)),
            (user.value.cartes && user.value.cartes[0]?.date_reception)
              ? (_openBlock(), _createElementBlock("span", _hoisted_179, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_180, "En attente"))
          ]),
          _cache[87] || (_cache[87] = _createElementVNode("h5", { class: "text-grey-900 my-2" }, "Point relais - collectivité", -1)),
          (user.value.cartes && user.value.cartes[0]?.date_reception)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_181, " Reçu le " + _toDisplayString(_unref(formatDate)(user.value.cartes[0].date_reception, 'DD/MM/YYYY HH:mm')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_182, "-"))
        ])
      ])
    ]),
    _cache[104] || (_cache[104] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[105] || (_cache[105] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[106] || (_cache[106] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_183, [
      _cache[93] || (_cache[93] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Prélèvement mensuel </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 white2 active\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Plan mensuel</span></button></div>", 2)),
      _createElementVNode("div", _hoisted_184, [
        _cache[91] || (_cache[91] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
        _createElementVNode("div", _hoisted_185, [
          _createElementVNode("div", _hoisted_186, _toDisplayString(quotiteUsedPercent.value) + "%", 1),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center rounded-100 px-7 bg-pop-green",
            style: _normalizeStyle(`width: ${quotiteUsedPercent.value}%;`)
          }, [
            _createElementVNode("h2", null, _toDisplayString(user.value.balance ? _unref(formatAmount)(user.value.balance) + ' F' : '0 F'), 1),
            _createElementVNode("h2", _hoisted_187, "  / " + _toDisplayString(user.value.quotite_cessible_montant ? _unref(formatAmount)(user.value.quotite_cessible_montant) + ' F' : (user.value.salaire ? _unref(formatAmount)(user.value.salaire) + ' F' : '-')), 1)
          ], 4)
        ]),
        _cache[92] || (_cache[92] = _createStaticVNode("<div class=\"clear-both h-30\"></div><div class=\"grid4 px-1\"><div class=\"widget border border-3 active shadow-200 rounded-30 gap-5 px-7 py-5\"><div class=\"s10\"><h6 class=\"secondary-font font-semibold mb-1\">01 Novembre 2025</h6><h3 class=\"secondary-font font-semibold text-grey-900 py-1\">250 000 F</h3></div><div class=\"s10 text-right\"><h5 class=\"secondary-font font-semibold text-grey-600 pb-2 display-none\">1m 29j 24min</h5><div class=\"mb-4\"><span class=\"tag-state notif stroke\">Effectué</span></div><h6 class=\"secondary-font font-semibold text-grey-600 pt-1 mb-4\">Le 11 Déc. 2025</h6><button class=\"btn-ultra w-100 shadow-0 display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div><div class=\"widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5\"><div class=\"s10\"><h6 class=\"secondary-font font-semibold mb-1\">01 Novembre 2025</h6><h3 class=\"secondary-font font-semibold text-grey-900 py-1\">250 000 F</h3></div><div class=\"s10 text-right\"><h5 class=\"secondary-font font-semibold text-grey-600 pb-2\">1m 29j 24min</h5><div class=\"mb-4 display-none\"><span class=\"tag-state notif stroke\">Effectué</span></div><h6 class=\"secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none\">Le 11 Déc. 2025</h6><button class=\"btn-ultra w-100 shadow-0\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div><div class=\"widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5\"><div class=\"s10\"><h6 class=\"secondary-font font-semibold mb-1\">01 Novembre 2025</h6><h3 class=\"secondary-font font-semibold text-grey-900 py-1\">250 000 F</h3></div><div class=\"s10 text-right\"><h5 class=\"secondary-font font-semibold text-grey-600 pb-2\">1m 29j 24min</h5><div class=\"mb-4 display-none\"><span class=\"tag-state notif stroke\">Effectué</span></div><h6 class=\"secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none\">Le 11 Déc. 2025</h6><button class=\"btn-ultra w-100 shadow-0 display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div><div class=\"widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5\"><div class=\"s10\"><h6 class=\"secondary-font font-semibold mb-1\">01 Novembre 2025</h6><h3 class=\"secondary-font font-semibold text-grey-900 py-1\">250 000 F</h3></div><div class=\"s10 text-right\"><h5 class=\"secondary-font font-semibold text-grey-600 pb-2\">1m 29j 24min</h5><div class=\"mb-4 display-none\"><span class=\"tag-state notif stroke\">Effectué</span></div><h6 class=\"secondary-font font-semibold text-grey-600 pt-1 mb-4 display-none\">Le 11 Déc. 2025</h6><button class=\"btn-ultra w-100 shadow-0 display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div></div><div class=\"collapse-content\"><div class=\"grid4 px-1\"> Plus </div></div><div class=\"clear-both h-15\"></div><span class=\"px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open align-right\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Voir tous </span>", 5))
      ])
    ]),
    _cache[107] || (_cache[107] = _createStaticVNode("<div class=\"clear-both h-5\"></div><div class=\"step vertical bg-grey-500 ml-auto mr-auto\"></div><div class=\"clear-both h-5\"></div><div class=\"s20 widget px-6 pt-8 pb-2\"><div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Décaissement mensuel </span></div><div class=\"s10 mt--5-5 flex-right gap-4\"><button class=\"btn lg py-3 white2 active\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Revolving</span></button></div><div class=\"s20 items-center gap-6 px-5 pb-4 collapse-content active\"><div class=\"clear-both h-10\"></div><div class=\"flex items-center gap-6\"><div class=\"s7\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-color-1000\"></div> Débloqué </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">+4.6%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white\" style=\"width:4.6%;\"> 4.6% </div></div></div><div class=\"s7\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-purple\"></div> Bloqué </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">95.4%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white\" style=\"width:95.4%;\"> 95.4% </div></div></div><div class=\"s6\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-green-light\"></div> Total </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2\">4 000 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">100%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light\" style=\"width:100%;\"> 100% </div></div></div></div><div class=\"clear-both h-30\"></div><div class=\"grid4 px-1\"><div class=\"widget border border-3 active shadow-200 rounded-30 gap-5 px-7 py-5\"><div class=\"s10\"><h6 class=\"secondary-font font-semibold mb-1\">01 Novembre 2025</h6><h3 class=\"secondary-font font-semibold text-grey-900 py-1\">378 830 F</h3><p class=\"secondary-font font-semibold text-purple\">1.5%</p></div><div class=\"s10 text-right\"><h5 class=\"secondary-font font-semibold text-primary-color pb-1 display-none\">1m 29j 24min</h5><div class=\"mb-4\"><span class=\"tag-state notif stroke\">Effectué</span></div><p class=\"secondary-font font-semibold text-grey-600 pt-1\">Date de déblocage</p><h6 class=\"secondary-font font-semibold text-grey-600 py-1\">11 Déc. 2025</h6></div><div class=\"s20 mt-2 display-none\"><p class=\"s10 font-medium text-sm text-grey-600 mt-2\"> Prélèvement <span class=\"text-sm color-success\">(Effectué)</span></p><div class=\"s10\"><button class=\"btn-ultra w-100\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Décaisser</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div></div><div class=\"widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5\"><div class=\"s10\"><h6 class=\"secondary-font font-semibold mb-1\">01 Novembre 2025</h6><h3 class=\"secondary-font font-semibold text-grey-900 py-1\">378 830 F</h3><p class=\"secondary-font font-semibold text-purple\">1.5%</p></div><div class=\"s10 text-right\"><h5 class=\"secondary-font font-semibold text-primary-color pb-1\">1m 29j 24min</h5><div class=\"mb-4 display-none\"><span class=\"tag-state notif stroke\">Effectué</span></div><p class=\"secondary-font font-semibold text-grey-600 pt-1\">Date de déblocage</p><h6 class=\"secondary-font font-semibold text-grey-600 py-1\">11 Déc. 2025</h6></div><div class=\"s20 mt-2\"><p class=\"s10 font-medium text-sm text-grey-600 mt-2\"> Prélèvement <span class=\"text-sm color-success\">(Effectué)</span></p><div class=\"s10\"><button class=\"btn-ultra w-100\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Décaisser</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div></div><div class=\"widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5 opacity-6\"><div class=\"s10\"><h6 class=\"secondary-font font-semibold mb-1\">01 Novembre 2025</h6><h3 class=\"secondary-font font-semibold text-grey-900 py-1\">378 830 F</h3><p class=\"secondary-font font-semibold text-purple\">1.5%</p></div><div class=\"s10 text-right\"><h5 class=\"secondary-font font-semibold text-primary-color pb-1\">1m 29j 24min</h5><div class=\"mb-4 display-none\"><span class=\"tag-state notif stroke\">Effectué</span></div><p class=\"secondary-font font-semibold text-grey-600 pt-1\">Date de déblocage</p><h6 class=\"secondary-font font-semibold text-grey-600 py-1\">11 Déc. 2025</h6></div><div class=\"s20 mt-2 display-none\"><p class=\"s10 font-medium text-sm text-grey-600 mt-2\"> Prélèvement <span class=\"text-sm color-success\">(Effectué)</span></p><div class=\"s10\"><button class=\"btn-ultra w-100\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Décaisser</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div></div><div class=\"widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5 opacity-6\"><div class=\"s10\"><h6 class=\"secondary-font font-semibold mb-1\">01 Novembre 2025</h6><h3 class=\"secondary-font font-semibold text-grey-900 py-1\">378 830 F</h3><p class=\"secondary-font font-semibold text-purple\">1.5%</p></div><div class=\"s10 text-right\"><h5 class=\"secondary-font font-semibold text-primary-color pb-1\">1m 29j 24min</h5><div class=\"mb-4 display-none\"><span class=\"tag-state notif stroke\">Effectué</span></div><p class=\"secondary-font font-semibold text-grey-600 pt-1\">Date de déblocage</p><h6 class=\"secondary-font font-semibold text-grey-600 py-1\">11 Déc. 2025</h6></div><div class=\"s20 mt-2 display-none\"><p class=\"s10 font-medium text-sm text-grey-600 mt-2\"> Prélèvement <span class=\"text-sm color-success\">(Effectué)</span></p><div class=\"s10\"><button class=\"btn-ultra w-100\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon\" alt=\"\"><span>Décaisser</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div></div></div></div><div class=\"collapse-content\"><div class=\"grid4 px-1\"> Plus </div></div><div class=\"clear-both h-15\"></div><span class=\"px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open align-right\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Voir tous </span></div></div><div class=\"clear-both h-5\"></div><div class=\"step vertical bg-grey-500 ml-auto mr-auto\"></div><div class=\"clear-both h-5\"></div><div class=\"s20 widget px-6 pt-8 pb-2\"><div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Wallet / Utilisation </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 white2 active\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Utilisation</span></button></div><div class=\"s20 gap-6 px-5 pb-8 collapse-content active\"><div class=\"clear-both h-10\"></div><div class=\"flex items-center gap-6\"><div class=\"s7\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-color-1000\"></div> Solde </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2 text-5xl\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">92%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white\" style=\"width:92%;\"> 92% </div></div></div><div class=\"s7\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-purple\"></div> Montant Utilisé </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2 text-5xl\">52 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">56.4%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white\" style=\"width:56.4%;\"> 56.4% </div></div></div><div class=\"s6\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-green-light\"></div> Dernier décaissement </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2 text-5xl\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">100%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light\" style=\"width:100%;\"> 100% </div></div></div></div></div></div><div class=\"clear-both h-80\"></div>", 9))
  ]))
}
}

})